import {Trans, useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {PATHS} from 'routes/constants';
import {usePath} from 'hooks';
import {IncompleteGuestText} from './styled';
import {Button, cn} from '@chekin/guestapp-ui-kit';

type IncompleteRegisteredGuestsStepProps = {
  hideTitle?: boolean;
  current: number;
  total: number;
};
function IncompleteRegisteredGuestsStep({
  hideTitle,
  current,
  total,
}: IncompleteRegisteredGuestsStepProps) {
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {t} = useTranslation();
  return (
    <>
      {!hideTitle && (
        <IncompleteGuestText
          className={cn(
            'chekin-next-step-modal__sub-title chekin-missing-guests',
            'kiosko:text-kiosko-m kiosko:mx-auto kiosko:mb-12',
          )}
        >
          <Trans
            i18nKey="you_have_registered_number_guest"
            values={{current, total}}
            components={[<></>, <b />]}
          />
        </IncompleteGuestText>
      )}

      <Button
        className="w-full kiosko:mx-auto kiosko:mb-12"
        onClick={() => navigate(getFullPath(PATHS.guestRegistration))}
      >
        {t('register_next_guest')}
      </Button>
    </>
  );
}

export {IncompleteRegisteredGuestsStep};
